import React from "react"
import PropTypes from "prop-types"

import "@blocknote/core/fonts/inter.css";
import { BlockNoteView } from "@blocknote/mantine";
import "@blocknote/mantine/style.css";
import { useCreateBlockNote } from "@blocknote/react";
 

const Note = (props) => {
  const editor = useCreateBlockNote();

  return (
    <React.Fragment>
      Blocknote
    </React.Fragment>
  )
}

export default Note
